import { render, staticRenderFns } from "./TrainerWechatDialog.vue?vue&type=template&id=598eff2e&scoped=true"
import script from "./TrainerWechatDialog.vue?vue&type=script&lang=js"
export * from "./TrainerWechatDialog.vue?vue&type=script&lang=js"
import style0 from "./TrainerWechatDialog.vue?vue&type=style&index=0&id=598eff2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598eff2e",
  null
  
)

export default component.exports